import $ from 'jquery';
window.$ = window.jQuery = $;

var variantQwiz_1 = 0;
var variantQwiz_2 = 0;
var variantQwiz_3 = 0;
var maxVariant = 0;
//NEST STEP SCRIPT
if ($(".step--js").length > 0) {
	$('.step--js').on("click", function (e) {
		e.preventDefault();
		var step = $(this).data("next-step");
		var currentStep = $('.quiz-step.active').data("step");
		var errorQwiz = false;
		if(currentStep == 1){
			let name = $('#qwiz_name').val();
			let phone = $('#qwiz_phone').val();
			let policy = $('#qwiz_policy:checked').val();

			if(name == '' || phone=='' || policy != 1){
				errorQwiz = true;
				$('.quiz-step__error').show();
			} else {
				$('.quiz-step__error').hide();
				$.post('/mail.php', {name:name, phone:phone});
			}
		}
		if(currentStep > 1){
			var val = $('.quiz-step.active').find('input[type="radio"]:checked').val();			
			if(val == 1){
				variantQwiz_1++;
			}
			if(val == 2){
				variantQwiz_2++;
			}
			if(val == 3){
				variantQwiz_3++;
			}

			if(val == undefined && currentStep<step){
				$('.quiz-step.active').find('.quiz-step__error').show();
				errorQwiz = true;
			}			
			maxVariant = Math.max(variantQwiz_1, variantQwiz_2, variantQwiz_3);
		}
		if(!errorQwiz){
			$(".quiz-step").removeClass("active");
			$(this).parents().find('.quiz-step[data-step="' + step + '"]').addClass("active");
			console.log(variantQwiz_1, variantQwiz_2, variantQwiz_3) ;
		}		
	});
}

if ($(".finish--js").length > 0) {
	$('.finish--js').on("click", function (e) {
		e.preventDefault();
		var finish = $(this).data("next-finish");
		var currentStep = $('.quiz-step.active').data("step");
		if(currentStep > 1){
			var val = $('.quiz-step.active').find('input[type="radio"]:checked').val();
			console.log(val);
			if(val == 1){
				variantQwiz_1++;
			}
			if(val == 2){
				variantQwiz_2++;
			}
			if(val == 3){
				variantQwiz_3++;
			}
			if(val == undefined){
				$('.quiz-step.active').find('.quiz-step__error').show();
				errorQwiz = true;
			}			
			maxVariant = Math.max(variantQwiz_1, variantQwiz_2, variantQwiz_3);
		}
		console.log(variantQwiz_1, variantQwiz_2, variantQwiz_3) ;
		if(maxVariant == variantQwiz_1){
			finish = 2;
		}
		if(maxVariant == variantQwiz_2){
			finish = 3;
		}
		if(maxVariant == variantQwiz_3){
			finish = 4;
		}
		
		$(".quiz__wrap").removeClass("active");
		$(this).parents().find('.quiz-finish[data-finish="' + finish + '"]').addClass("active");
	});
}

